import React from "react"
import { Router } from "@reach/router"

import SEO from "../../components/seo"
import Header from "../../components/Header"

import ScrollSpy from './../../components/ScrollSpy'
import List from './../../components/news/List'
import Single from './../../components/news/Single'

export default () => {

  return (
    <div className="slideInTop">
      <SEO title="اخبار" />
      <Header />
      <ScrollSpy />
      <div id="parrent" className="overflow-auto rtl">
        <div className="mx-auto" style={{ height: 'calc(100vh - var(--top-nav-height))' }}>
          <Router basepath="/news">
            <List path="/list" />
            <Single path="/list/:id" />
          </Router>
        </div>
      </div>
    </div>
  )
}
